import React from 'react'
import { Link } from 'gatsby'
import { Menu, X } from 'lucide-react'
import { Container } from '../ui/container'
import verbatimLogo from '../verbatim_logo.png'

type NavItem = { label: string; to: string }

const nav: NavItem[] = [
  { label: 'Home', to: '/#home' },
  { label: 'Partners', to: '/#partners' },
  { label: 'FAQ', to: '/#faq' },
  { label: 'Research', to: '/research/' },
]

export function Header() {
  const [open, setOpen] = React.useState(false)
  const buttonClass =
    'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition focus:outline-none focus:ring-2 focus:ring-secondary/40 disabled:opacity-50 disabled:pointer-events-none h-11 px-6 text-base bg-secondary text-secondary-foreground shadow-sm hover:brightness-[0.98]'

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-primary/10 bg-body/95 backdrop-blur">
      <Container className="h-16 flex items-center justify-between">
        <Link to="/#home" className="flex items-center gap-2 no-underline">
          <img
            src={verbatimLogo}
            alt="Verbatim"
            width={116}
            height={36}
            className="h-8 w-auto sm:h-9"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          {nav.map((item) => (
            <Link
              key={item.label}
              to={item.to}
              className="rounded-md px-3 py-2 text-foreground hover:bg-primary/5"
            >
              {item.label}
            </Link>
          ))}

          <a href="mailto:contact@rubidiumdata.com" className={buttonClass}>
            Get in Touch
          </a>
        </nav>

        <button
          type="button"
          className="md:hidden inline-flex items-center justify-center rounded-md p-2 text-foreground hover:bg-primary/5 focus:outline-none focus:ring-2 focus:ring-secondary/40"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
        </button>
      </Container>

      {open ? (
        <div className="md:hidden border-t border-primary/10 bg-body">
          <Container className="py-3 flex flex-col gap-2">
            {nav.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="rounded-md px-3 py-2 text-foreground hover:bg-primary/5"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <a href="mailto:contact@rubidiumdata.com" className={buttonClass}>
              Get in Touch
            </a>
          </Container>
        </div>
      ) : null}
    </header>
  )
}
